(function() {
    'use strict';

    var NotificationQueue = Klazz.extend({
        _isReady: false,
        _readyQueue: null,

        initialize: function() {
            this._readyQueue = [];
        },

        /**
         * Similar to jQuery.ready, registers a method to be executed when the
         * data is loaded
         */
        ready: function(callback) {
            if (this._isReady) {
                callback();
                return;
            }

            this._readyQueue.push(callback);
        },

        process: function() {
            // We set isReady first to prevent cases when user calls ready inside ready
            this._isReady = true;
            this._readyQueue.forEach(function(callback) {
                try {
                    callback();
                } catch (e) {
                    // Silently catch errors because we don't want external code to
                    // break the queue
                    console && console.error && console.error(e);
                }
            });
            this._readyQueue = [];
        }
    });

    module.exports = NotificationQueue;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/NotificationQueue.js
 ** module id = 665
 ** module chunks = 0
 **/